export default __webpack_public_path__ + "static/media/pau.c319a9fe.png";